import { createTheme } from '@mui/material/styles';
import './../../App.css'

// Service-specific primary colors — change these to rebrand each service
export const SERVICE_COLORS = {
  pagination: {
    light: '#C0E1F8',
    main: '#3397E2',
    dark: '#336FB6',
    contrastText: '#ffffff',
  },
  labels: {
    light: '#C0E1F8',
    main: '#3397E2',
    dark: '#336FB6',
    contrastText: '#ffffff',
  },
};

const Primarytheme = createTheme({

  palette: {
    // attack mui CssBaseline compoent
    background: {
      default: '#EDEDED',
    },


    primary: {
      ...SERVICE_COLORS.pagination,
    },

    secondary: {
      light: '#A2F1D2',
      main: '#2FCD8F',
      dark: '#26A976',
      contrastText: '#ffffff',
    },
    neutral: {
      light: '#CECECE',
      main: '#8F8F8F',
      dark: '#686868',
      contrastText: '#ffffff',
    },
    lightPrimary: {
      light: '#CECECE',
      main: '#b5b5b5',
      dark: '#686868',
      contrastText: '#ffffff',
    },
    white: {
      light: '#ffffff',
      main: '#ffffff',
      dark: '#336FB6',
      contrastText: '#000000',
    },

    error: {
      main: '#C13030',
      dark: '#802020',
      light: '#FF4D4D'
    },

    success: {
      light: '#A2F1D2',
      main: '#26A976',
      dark: '#26A976',
      contrastText: '#ffffff',
    },

    warning: {
      main: '#EF9C41',
      dark: '#B37430',
      light: '#EF9C41',
      contrastText: '#ffffff',
    },
  },
  typography: {
    fontFamily: [
      'Work Sans',
    ].join(','),

  },
  components: {
    MuiGrid: {
      defaultProps: {
        unstable_level: 2
      }
    },
    MuiAlert: {
      styleOverrides: {
        filledSuccess: {
          color: '#ffffff',
        },
      }
    }
  }
});

export default Primarytheme


